import { useTranslation } from "react-i18next";

import { RewardStatusType } from "../../../configs/models/constants";
import type { Status } from "../RewardCard";

export const RewardStatus = ({ status }: { status: Status }) => {
  const { t: translate } = useTranslation("translation");
  switch (status) {
  case RewardStatusType.VALID:
    return (
      <span className="rounded-full bg-successColor/20 px-2 py-1 text-mainTextColor">
        {translate("valid")}
      </span>
    );

  case RewardStatusType.EXPIRED:
    return (
      <span className="rounded-full bg-errorColor/20 px-2 py-1 text-errorColor">
        {translate("expired")}
      </span>
    );

  case RewardStatusType.BURNED:
    return (
      <span className="rounded-full bg-errorColor/20 px-2 py-1 text-errorColor">
        {translate("burnt")}
      </span>
    );

  default:
    return null;
  }
};
